var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import Select from '../../components/Select';
import Input from '../../components/Input';
import WithValidation from '../../lib/WithValidation';
import require from '../../lib/WithValidation/rules/required';
import PropTypes from 'prop-types';
import Translate from '../../components/Translate';
import translate from '../../lib/utils/translate';

var Verify = function (_PureComponent) {
  _inherits(Verify, _PureComponent);

  function Verify() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Verify);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Verify.__proto__ || Object.getPrototypeOf(Verify)).call.apply(_ref, [this].concat(args))), _this), _this._handleSelectType = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onSelectType = _this$props.onSelectType;

      var type = e.currentTarget.value;
      onChange('Type', type);
      onSelectType && onSelectType(type);
    }, _this._handleUploadPhoto = function () {
      var onChange = _this.props.onChange;


      if (_this.uploadInput.files && _this.uploadInput.files[0]) {
        var files = _this.uploadInput.files;

        onChange('Image', files[0]);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Verify, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          intl = _props.intl,
          errors = _props.errors,
          onSubmit = _props.onSubmit,
          types = _props.types,
          instructions = _props.instructions;


      return React.createElement(
        'form',
        { onSubmit: onSubmit },
        React.createElement(Select, {
          className: 'layout-item-6 select-type-input',
          id: 'type-select-kyc',
          name: 'Type',
          options: types.map(function (t) {
            return {
              value: t.value,
              label: translate({ id: t.label }, intl)
            };
          }),
          error: errors.Type && translate({ id: errors.Type }, intl),
          onChange: this._handleSelectType,
          title: translate({ id: 'label.select_type_title' }, intl)
        }),
        instructions,
        React.createElement(
          'div',
          { className: 'layout-item-12 kyc-upload-wrapper' },
          React.createElement(Input, {
            ref: function ref(node) {
              if (node) _this2.uploadInput = node;
            },
            name: 'Image',
            className: 'upload-input layout-item-12',
            id: 'verify-profile',
            type: 'file'
          }),
          React.createElement(
            'div',
            { className: 'upload-description' },
            translate({
              id: 'label.upload_document_description'
            }, intl)
          ),
          React.createElement(
            'button',
            {
              className: 'button primary layout-item-12 kyc-upload-button',
              ref: function ref(node) {
                return _this2.submitButton = node;
              },
              type: 'submit',
              onClick: this._handleUploadPhoto },
            React.createElement(Translate, {
              defaultMessage: 'Upload document',
              id: 'button.upload_document'
            })
          )
        ),
        React.createElement(
          'span',
          { className: 'error-message' },
          errors.Image && translate({ id: errors.Image }, intl)
        )
      );
    }
  }]);

  return Verify;
}(PureComponent);

var rules = {
  Type: [[require, 'error.empty.type']],
  Image: [[require, 'error.empty.image']]
};

Verify.propTypes = {
  /** If any errros occur this object will show the error message */
  errors: PropTypes.object,
  /** The submission function firing when submitting the form */
  onSubmit: PropTypes.func,
  /** A collection of types to choose from */
  types: PropTypes.array,
  /** HTML to provide instructions */
  instructions: PropTypes.any
};

Verify.defaultProps = {
  errors: {},
  onSubmit: function onSubmit() {},
  types: [],
  instructions: ''
};

export default compose(WithValidation(rules), injectIntl)(Verify);